import { render, staticRenderFns } from "./Eyes.vue?vue&type=template&id=6bd71a48&scoped=true&lang=pug"
import script from "./Eyes.vue?vue&type=script&lang=js"
export * from "./Eyes.vue?vue&type=script&lang=js"
import style0 from "./Eyes.vue?vue&type=style&index=0&id=6bd71a48&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd71a48",
  null
  
)

export default component.exports